import React, { useCallback } from 'react';
import { Mountain, ArrowLeft, Mail, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const emailCharCodes = [109, 97, 105, 108, 116, 111, 58, 115, 117, 112, 112, 111, 114, 116, 64, 114, 111, 97, 109, 97, 112, 112, 115, 46, 99, 111, 109];

function decodeEmail(): string {
  return emailCharCodes.map((c) => String.fromCharCode(c)).join('');
}

export const Support: React.FC = () => {
  const handleContact = useCallback((evt: React.MouseEvent) => {
    evt.preventDefault();
    window.location.href = decodeEmail();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center space-x-3">
              <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-2 rounded-xl">
                <Mountain className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Roam</h1>
                <p className="text-sm text-gray-600">Outdoor Adventure Apps</p>
              </div>
            </Link>

            <nav className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors">
                Home
              </Link>
              <a
                href="https://weather.roamapps.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors"
              >
                Try Weather
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Support Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link
          to="/"
          className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors mb-8"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 sm:p-12">
          <div className="flex items-center space-x-3 mb-6">
            <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-3 rounded-xl">
              <MessageCircle className="h-6 w-6 text-white" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900">Support</h2>
          </div>

          <p className="text-gray-600 text-lg mb-8">
            If you run into an issue or have a question about any of the Roam apps,
            feel free to reach out.
          </p>

          <div className="bg-blue-50 rounded-xl p-6 border border-blue-100">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              Get in Touch
            </h3>
            <p className="text-gray-600 mb-4">
              Send us an email and we'll get back to you when we can.
            </p>
            <button
              onClick={handleContact}
              className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors font-medium"
            >
              <Mail className="h-5 w-5 mr-2" />
              Send Email
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};
